import { UseFormReturn } from "react-hook-form";

export const isFormDirty = (form: UseFormReturn<any>) => {
  return Object.keys(form.formState.dirtyFields).length > 0;
};
